<template>
   <a-card :bordered="false">
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item label="" name="amount">
            <a-row :gutter="10">
              <div class="width-100 s_flex_ali" :span="3">
                <a-checkbox v-model:checked="form.is_amount" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">每消费</p>
              </div>
              <a-col :span="6">
                <a-input-number v-model:value="form.amount"    style="width:100%" placeholder='请输入消费金额' :min='1' :precision='2' />
              </a-col>
              <a-col :span="6">
                <p>元，增加1成长值</p>
              </a-col>
            </a-row>
          </a-form-item>
          <!-- <a-form-item label="" name="point">
            <a-row :gutter="10">
              <div class="width-100 s_flex_ali" :span="3">
                <a-checkbox v-model:checked="form.is_point" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">每获得</p>
              </div>
              <a-col :span="12">
                <a-input-number v-model:value="form.point" style="width:100%" placeholder='请输入获得积分' :min='1' />
              </a-col>
              <a-col :span="6">
                <p>积分，增加1成长值</p>
              </a-col>
            </a-row>
          </a-form-item> -->
          <a-form-item label="" name="scan_count">
            <a-row :gutter="10">
              <div class="width-100 s_flex_ali" :span="3">
                <a-checkbox v-model:checked="form.is_scan" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">每扫码</p>
              </div>
              <a-col :span="6">
                <a-input-number v-model:value="form.scan_count" style="width:100%" placeholder='扫码次数' :min='1' :precision='0'  />
              </a-col>
              <a-col :span="6">
                <p>次，增加1成长值</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
            <a-button style="width:100px" type="primary" v-has:setMemberGrowth="onSubmit">
              保存
            </a-button>
          </a-form-item>
        </a-form>
   </a-card>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import {getMemberExpConfig,setMemberExpConfig} from '@/api/member'
import {iscode} from '@/utils/app';
  import { message } from 'ant-design-vue';
  // 初始化默认筛选项数值
  let defForm = {
    is_scan:0,
    scan_count:1,
    // point:null,
    // is_point:0,
    is_amount:0,
    amount:1,
  }
  export default {
    name:'growth',
    components: {
    },
    setup() {
      let amount = async () => {
        if (form.value.is_amount && !isNumber(form.value.amount)) {
          return Promise.reject('请输入消费金额');
        } else {
          return Promise.resolve();
        }
      };
      let scan_count = async () => {
        if (form.value.is_scan && !isNumber(form.value.scan_count)) {
          return Promise.reject('请输入扫码次数');
        } else {
          return Promise.resolve();
        }
      };
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 6},
        wrapperCol: { span:17},
        rules:{
          amount: [
            { required: true, validator: amount }
          ],
          scan_count: [
            { required: true, validator: scan_count }
          ],
        }
      });
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      const init=async()=>{
        let result =await getMemberExpConfig().then(res=>res.data).catch(error=>error)
        if(result.data.amount){
        form.value=result.data
        }
      }
      init()
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then( async() => {
          let result=await setMemberExpConfig(form.value).then(res=>res.data).catch(error=>error)
          iscode(result,true)
        }).catch((error) => { });
       }
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        isNumber
      }
    }
  }
</script>